import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { Button, ListItem, ListItemIcon, ListItemText } from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import { Location } from "@reach/router"


const LinkWrapperButton = withStyles(() => ({
  root: {
    textTransform: "none",
    width: "100%",
    padding: 0,
  },
}))(Button)


export function NavLink(props) {
  const {to, icon} = props
  let primary = (
    <>
      <span>{props.text}</span>
      {props.children}
    </>
  )
  return (
    <Location>
      {
        locationProps => (
          <ListItem>
            <LinkWrapperButton>
              <Link
                to={to}
                className={
                  `nav__link ${(to === locationProps.location.pathname) ? "nav__link--active" : ""}`
                }
              >
                {icon ? <ListItemIcon>{icon}</ListItemIcon> : ""}
                {locationProps.location.pathName}
                <ListItemText disableTypography primary={primary}/>
              </Link>
            </LinkWrapperButton>
          </ListItem>
        )
      }
    </Location>
  )
}


NavLink.propTypes = {
  to: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.node,
  children: PropTypes.node,
}

export default NavLink
